export interface StateData {
  [key: string]: {
    title: string;
    subtitle: string;
    media: {
      gatsbyImage: any;
      title: string;
      file: {
        url: string;
      };
    };
    config: {
      showServiceChannel: boolean;
      showBackButton: boolean;
      showCertificateButton: boolean;
    };
  };
}

export const StateOfHousingAllowanceResultAdapter = (data: any): StateData => {
  const states = data.referenceBlock;
  const stateJson: StateData = {};

  states.forEach((state: any) => {
    stateJson[state.contentfulid] = {
      title: state.title,
      subtitle: state.subtitle,
      media: {
        gatsbyImage: state.media.gatsbyImage,
        title: state.media.title,
        file: {
          url: state.media.file.url,
        },
      },
      config: JSON.parse(state.config[0].internal.content),
    };
  });
  return stateJson;
};
